module.exports = __webpack_public_path__ + "media/customizations/fccsa/logo-c11081ef15fe68f41b35d116a98e75f7.png";